<template>
  <div class="form-page" v-if="showInput && inputsPrepared">
    <div v-for="(val, index) in 3" :key="index" class="bottom-margin">
      <div class="form-input__wrap" :class="{ hidden: history[currentStep + index].field.hidden}">
        <input
          :type="history[currentStep + index].field.type"
          class="form-input"
          v-model="inputVal[index]"
          @keyup="handleKeydown"
          :name="history[currentStep + index].name"
          v-bind:class="{error: history[currentStep + index].showError}"
          :placeholder="history[currentStep + index].field.placeholder"
          required>
        <span
          v-if="showInput"
          class="form-input-floating-label"
          v-bind:class="{error: history[currentStep + index].showError}"
        >{{history[currentStep + index].field.placeholder}}</span>
      </div>
      <transition name="fade">
        <span class="error-message" v-if="history[currentStep + index].showError">
          {{history[currentStep + index].field.error}}
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import Inputmask from 'inputmask'

export default {
  name: 'ThreeFields',
  data () {
    return {
      inputVal: [],
      initValue: false,
      inputsPrepared: false
    }
  },
  computed: {
    isValid () {
      const isValidFromArray = (index) => {
        const regex = new RegExp(this.history[this.currentStep + index].field.reg)
        let result = this.inputVal[index] ? regex.test(this.inputVal[index]) : ''
        if (result === '' && regex.test(this.inputVal[index])) result = true
        return result
      }
      return [isValidFromArray(0), isValidFromArray(1), isValidFromArray(2)]
    },
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep,
      showInput: state => state.showInput,
      config: state => state.config,
      provider: state => state.additionalParams.provider
    })
  },
  mounted () {
    let temp = this.history
    const addFieldInfo = (step) => {
      const fieldInfo = this.$store.getters.getFieldInfoByName(this.history[step].name)
      Vue.set(temp[step], 'field', fieldInfo)
      let skip = true
      // check if next fields belongs to nss or three-fields, for avoid process loop
      // It can be caused when backend requests just one field
      if (!['nss', 'three-fields'].includes(fieldInfo['game-type'])) skip = false
      Vue.set(temp[step], 'skip', skip)
    }

    for (let i = 0; i < 3; i++) {
      const step = this.currentStep + i
      if (i > 0) addFieldInfo(step)

      const mask = temp[step].field['game-mask']
      if (mask) this.addMask(temp[step].name, mask)

      this.inputVal.push(temp[step].value || '')
    }

    this.$store.commit('CHANGE_HISTORY', temp)
    this.inputsPrepared = true
  },
  watch: {
    inputVal: function (val) {
      if (!this.initValue) { this.initValue = true; return }
      val.forEach((value, index) => {
        this.$store.commit('UPDATE_FIELD', { customStep: this.currentStep + index, isValid: this.isValid[index], value, showError: false })
      })
    }
  },
  methods: {
    handleKeydown (e) {
      if (e.keyCode === 13) {
        this.$store.dispatch('nextStepPrepare', +1)
      }
    },
    addMask (name, mask) {
      return new Promise(resolve => {
        const options = {
          positionCaretOnClick: 'radixFocus',
          showMaskOnHover: false
        }
        const newMask = new Inputmask(mask, options)
        setTimeout(() => {
          newMask.mask(document.getElementsByName(name)[0])
          resolve()
        }, 50)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/fields/ThreeFields.vue